<ng-container *transloco="let t">
	<div class="relative z-50 w-full border-b border-solid border-gray-550 bg-white p-4">
		<div class="mx-auto flex w-full max-w-content flex-row flex-wrap items-center justify-between">
			<app-logo></app-logo>
			<div class="flex flex-row flex-wrap items-center">
				<app-language-switcher></app-language-switcher>
				<ng-container *showIfLoggedIn="true">
					<app-profile-button></app-profile-button>
				</ng-container>
				<a *showIfLoggedIn="false" class="ml-4 text-sm text-gray-700 hover:text-orange-500" routerLink="/register" title="{{ t('UI.register_now') }}">{{ t('UI.register') }}</a>
				<button
					*showIfLoggedIn="false"
					class="ml-4 appearance-none rounded-lg bg-blue-500 px-4 py-2 text-sm font-medium text-white md:px-8"
					(click)="goLogin()"
					title="{{ t('UI.login_now') }}"
				>
					<fa-icon class="block md:hidden" [icon]="faSignIn"></fa-icon>
					<span class="hidden md:block">{{ t('UI.login') }}</span>
				</button>
				<button *showIfLoggedIn="true" class="ml-4 appearance-none rounded-lg bg-blue-500 px-4 py-2 text-sm font-medium text-white md:px-8" (click)="logout()">
					<fa-icon class="block md:hidden" [icon]="faSignOut"></fa-icon>
					<span class="hidden md:block">{{ t('UI.logout') }}</span>
				</button>
			</div>
		</div>
	</div>
</ng-container>
